export default {"src":"/_next/static/media/ROG.07e4804e.svg","height":18,"width":18};